import { Component } from 'react';
import smoothscroll from 'smoothscroll-polyfill';
// @ts-ignore
import { Router } from '../configs/routes';
import Header from './header';
import { FooterNew } from './footer';
import ContainerLayout from './common/containerLayout';
import GoogleYolo from './common/googleYolo';
import ToastMessageBox from './common/toastMessageBox';
import DownloadProof from './dashboard/downloadProofHandler';
import {
  redirectToLastRoute,
  lazyLoadImages,
  isMobileDevice,
} from '../utils/commonUtils';
import {
  handlePageDataRequests,
  getUserSession,
  showError,
  redirectToLoginPage,
} from '../utils';
import cx from 'classnames';
import cookie from 'react-cookies';
import manageRouteTransition from '../utils/routingManager';
import { Api } from '../api';
import getConfig from 'next/config';
import '../styles/global.scss';
import envConfig from '../configs/env-config';

import styles from '../styles/index.scss';
import { trackPage, trackAction } from '../utils/trackActions';
import { KEY_F2S_PAGE_STATE } from '../constants/filingToSave';
import MobileHeader from './MobileHeader';
import BlackNudge from './homePage/experimental/blackNudge';
import NavigationNew from './NavigationNew';
import NavbarCurrency from './NavbarCurrency';
// import BannerBlack from './homePage/experimental/bannerBlack';
import { ApolloProvider } from 'react-apollo';

import TncModal from './tncModal';
import { client } from '../configs/apollo';
import { setUserInfo } from '../utils/sessionUtil';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
  window.__forceSmoothScrollPolyfill__ = true;
}

let flag = true;

const { publicRuntimeConfig } = getConfig();

const GOOGLE_YOLO_CLIENT_ID = envConfig.GOOGLE_YOLO_CLIENT_ID;

const api = new Api();

const withAppLayout = (data: any, ComposedComponent: any) => {
  class AppLayout extends Component<any, any> {
    public static async getInitialProps(ctx: any) {
      const { req, res, pathname, asPath, query } = ctx;
      const isOnServer = req && res;
      const userAgents = ['iPhone', 'iPad', 'iPod', 'Android', 'Mobile'];
      let isMobile;
      if (isOnServer) {
        isMobile = 0;
        userAgents.forEach((agent) => {
          isMobile = isMobile + req.headers['user-agent'].includes(agent);
        });
        isMobile = isMobile > 0;
      } else {
        isMobile = isMobileDevice();
      }
      /**
       * redirect user to /dashboard when page is ssr and the url has query params
       */
      if (
        isOnServer &&
        pathname === '/dashboard' &&
        (query.fundId || query.detailsSlug)
      ) {
        res.redirect('/save/dashboard/portfolio');
      }

      if (isOnServer && pathname === '/status' && !query.name) {
        res.redirect('/save/status/orders');
      }

      const customApi = new Api(req, res);

      const { token } = query;
      if (token) {
        await customApi.getDirectLogin(token);
      }

      const userInfo = await getUserSession(customApi);
      if (!userInfo && data.requireAuth) {
        redirectToLoginPage(req, res);
      }
      const abTest: any = { mfpages: true };
      const pageData = await handlePageDataRequests(ctx, customApi);
      /**
       * If pageData is redirect then handlePageDataRequests has internally
       * redirected to some other page and further operations with response
       * should not take place
       */
      if (pageData === 'redirect') {
        return;
      }

      // TODO: will have to revisit this for refactoring
      if (data.showSidebar) {
        if (!pageData.hasOwnProperty('mandateList')) {
          const mandateList = await customApi.getMandatesList();
          pageData['mandateList'] = mandateList;
        }
      }
      // Redirect to new mobile friendly design if user agent is mobile
      if (
        isOnServer &&
        (asPath === '/save/f2s' || asPath === '/save/f2s/') &&
        isMobile
      ) {
        res.redirect(`/save/f2s/2019-v3`);
      }
      if (isOnServer && asPath === '/save/personalized-plan') {
        const cookies = req.headers.cookie
          .split('; ')
          .reduce((prev: any, current: any) => {
            const [name, value] = current.split('=');
            prev[name] = value;
            return prev;
          }, {});
        const lastURL = cookies[KEY_F2S_PAGE_STATE];
        if (lastURL) {
          const url = decodeURIComponent(lastURL);
          const newURL = url.replace('/save/f2s', '/save/personalized-plan');
          res.redirect(newURL);
        }
      }

      if (
        isOnServer &&
        (asPath === '/save/personalized-plan' ||
          asPath === '/save/personalized-plan/') &&
        isMobile
      ) {
        res.redirect(`/save/personalized-plan/2019-v3`);
      }

      if (isOnServer && pathname === '/f2s' && !query['f2s_version']) {
        if (
          pageData.taxableSalary <= 2000000 &&
          pageData.investments80C < 150000
        ) {
          res.redirect(`/save/f2s/2019-v2`);
        } else {
          res.redirect(`/save/f2s/2019-v5`);
        }
      }

      if (
        isOnServer &&
        (/save\/(f2s|personalized-plan)\/2019-v[0-9]/.test(asPath) ||
          pageData.forceRedirect) &&
        !query.variant
      ) {
        res.redirect(`${pageData.redirectURL}`);
      }

      if (!userInfo) {
        if (typeof sessionStorage !== 'undefined') {
          sessionStorage.removeItem('hideModal');
        } else {
          showError('Please use the browser in non incognito mode');
        }
      }
      /**
       * If user comes to login page when he's already logged in, redirect him to homepage.
       * Move this logic to a better place.
       */
      if (
        req &&
        (req._parsedUrl.pathname === '/save/login' ||
          req._parsedUrl.pathname === '/save/loginnull') &&
        userInfo
      ) {
        res.redirect(req.query.refer || '/save');
        res.end = 'Redirected';
        res.finished = true;
      }
      return {
        ...pageData,
        userInfo,
        isMobile,
        abTest,
      };
    }

    public state: any = {
      pendingActions: [],
      userInfo: null,
      loadOneTap: false,
      showToastMsg: false,
      fetchingPendingActions: data.showSidebar,
      mandateData: null,
      showNudge: true,
      abTestFromStorage: null,
      isMfPoliciesAccepted: true,
      globalPolicies: [],
      elssInvestmentYears: [],
      downloadInvestmentProof: false,
    };

    public closeNudge = () => {
      this.setState({ showNudge: false });
    };

    public dismissTncModal = () => {
      this.setState({
        isMfPoliciesAccepted: true,
      });
    };
    public addInstallPromptEvent = async () => {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        window.addEventListener(
          'beforeinstallprompt',
          (e) => {
            const expires = new Date();
            const alreadyInteractedCookie = cookie.load(
              'appInstallInteraction'
            );
            expires.setDate(expires.getDate() + 7);
            const alreadyInteractedSession = sessionStorage.getItem(
              'alreadyInteractedSession'
            );
            if (
              alreadyInteractedSession ||
              alreadyInteractedCookie === 'second'
            ) {
              e.preventDefault();
            } else {
              e.prompt();
              e.userChoice.then(async (choice) => {
                if (choice.outcome !== 'accepted') {
                  sessionStorage.setItem(
                    'alreadyInteractedSession',
                    'interacted'
                  );
                  const value =
                    alreadyInteractedCookie === 'first' ? 'second' : 'first';
                  cookie.save('appInstallInteraction', value, {
                    expires,
                    path: '/',
                  });
                }
              });
            }
          },
          { once: true }
        );
      }
    };

    public setAllGlobalPolicies = async () => {
      const res = await api.getLatestPolicies();
      if (res) {
        this.setState({ globalPolicies: res });
      }
    };

    private fetchElssInvestmentYears = async () => {
      const elssInvestmentYears = await api.getElssInvestedYears();
      const {
        success,
        message = 'Something went wrong',
        response,
      } = elssInvestmentYears;
      if (!success) {
        showError(message);
        return;
      }
      this.setState({
        elssInvestmentYears: response,
      });
    };

    private showInvestmentProofModal = () => {
      this.setState({
        downloadInvestmentProof: true,
      });
    };

    public getPoliciesStatus = async () => {
      const res = await api.getCurrentUserDetails();
      if (res && res.response) {
        const { policiesAccepted } = res.response;
        let mfpolicies = [];
        if (policiesAccepted) {
          mfpolicies = policiesAccepted.filter(
            (item) =>
              (item.policyName === 'master_tnc' &&
                item.policyVersion === item.latestPolicyVersion) ||
              (item.policyName === 'master_privacy_policy' &&
                item.policyVersion === item.latestPolicyVersion)
          );
        }
        if (!mfpolicies.length) {
          this.setState({
            isMfPoliciesAccepted: false,
          });
        }
      }
    };

    public async componentDidMount() {
      if (window && 'serviceWorker' in window.navigator) {
        window.navigator.serviceWorker.register(`/save/sw.js`, {
          scope: '/save',
        });
      }
      lazyLoadImages('img');
      this.addInstallPromptEvent();
      manageRouteTransition();
      const { userInfo, abTest } = this.props;
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
      let localVal = JSON.parse(sessionStorage.getItem('abTest'));
      if (localVal && localVal.mfpages !== abTest.mfpages) {
        sessionStorage.setItem('abTest', JSON.stringify(abTest));
        localVal = abTest;
      }
      if (localVal) {
        this.setState({
          abTestFromStorage: localVal,
        });
      } else {
        sessionStorage.setItem('abTest', JSON.stringify(abTest));
      }
      if (flag) {
        const pagename = location.pathname + location.search;
        trackPage(pagename);
        flag = false;
      }
      this.setState({
        loadOneTap: !userInfo,
      });

      if (userInfo) {
        this.setPendingActionsValues();
        this.getPoliciesStatus();
        this.setAllGlobalPolicies();
        this.fetchElssInvestmentYears();
      }

      if (data.showSidebar) {
        this.setMandateData();
      }
    }
    public componentDidUpdate() {
      const localVal = JSON.parse(sessionStorage.getItem('abTest'));
      const { abTestFromStorage } = this.state;
      if (localVal && !abTestFromStorage) {
        this.setState({
          abTestFromStorage: localVal,
        });
      }
    }

    public componentDidCatch(error: any, errorInfo: any) {
      if (publicRuntimeConfig.isProd) {
        Sentry.withScope((scope) => {
          scope.setExtras(errorInfo);
          Sentry.captureException(error);
        });
      }
    }

    private async setPendingActionsValues() {
      this.setState({
        fetchingPendingActions: true,
      });
      const pendingActions = await api.getPendingActions();
      this.setState({
        pendingActions: pendingActions.response,
        fetchingPendingActions: false,
      });
    }

    private async setMandateData() {
      const mandateData = await api.getMandateInfo('DIRECT');
      this.setState({
        mandateData,
      });
    }

    public handleNavigation = async (slug: string, to: string, e: Event) => {
      if (e) {
        e.preventDefault();
      }
      if (slug) {
        Router.pushRoute(to, { slug });
      } else {
        Router.pushRoute(to);
      }
    };

    public authenticateUserFromGoogle = async () => {
      const userInfo = await getUserSession(api);
      setUserInfo(userInfo);
      trackAction('login-signup-click', 'one-tap-login');
      sessionStorage.removeItem('hideModal');
      this.setState({
        userInfo,
        loadOneTap: !userInfo,
        showToastMsg: true,
      });
      if (
        this.props.url.pathname === '/login' ||
        this.props.url.pathname === '/loginnull'
      ) {
        redirectToLastRoute('login-with-onetap');
      }
    };

    public postOneTapSuccessful = () => {
      setTimeout(() => {
        this.setState({ showToastMsg: false });
      }, 5000);
    };

    public render() {
      const {
        personalisedPlanPage,
        showSidebar,
        hideHeader,
        hideFooter,
        title,
        description,
        canonicalUrl,
        hideDefaultCanonical,
        hideHeaderSearch,
        showHeaderNavLinks,
        noIndex = false,
        showMobileHeader = false,
      } = data;
      const { mandateList, url, userInfo, isMobile, abTest } = this.props;
      const { pathname, query } = url;
      const { abTestFromStorage } = this.state;
      const abTestToGA = abTestFromStorage
        ? 'mfpages-true'
        : abTest && abTest['mfpages']
        ? 'mfpages-true'
        : false;

      const { alreadyInvested: hasUserInvested = false } = userInfo || {};
      const {
        pendingActions,
        loadOneTap,
        showToastMsg,
        fetchingPendingActions,
        mandateData,
        showNudge,
        isMfPoliciesAccepted,
        globalPolicies,
        downloadInvestmentProof,
        elssInvestmentYears,
      } = this.state;

      const nudgeRequired = pathname === '/single-fund' || pathname === '/plan';
      const nudgeRedirectURL =
        pathname === '/single-fund'
          ? `https://black-cleartax.app.link/fund?id=${query.fundIsin}`
          : `https://black-cleartax.app.link/plan?id=${query.id}`;
      return (
        <ApolloProvider client={client}>
          <section className={'new-font'}>
            {showToastMsg ? (
              <ToastMessageBox
                oneTapSuccessCallback={this.postOneTapSuccessful}
                toastMessage={"You've logged in successfully"}
              />
            ) : null}
            {nudgeRequired && showNudge ? (
              <BlackNudge
                isMobile={isMobile}
                closeNudge={this.closeNudge}
                redirectURL={nudgeRedirectURL}
              />
            ) : null}

            <Header
              title={title}
              description={description}
              canonicalUrl={canonicalUrl}
              hideDefaultCanonical={hideDefaultCanonical}
              noIndex={noIndex}
              applyV2Styles={true}
              abTestForGA={abTestToGA}
            />
            <div
              className={cx(
                styles['foundation-grid'],
                { [styles['foundation-grid']]: !hideFooter },
                'content-wrapper foundation-grid app-cont'
              )}
            >
              {!hideHeader &&
                !showMobileHeader &&
                (pathname !== '/currency' ? (
                  <NavigationNew
                    isUserLoggedIn={userInfo || this.state.userInfo}
                    isPersonalisedPlanPage={personalisedPlanPage}
                    hasSidebar={showSidebar}
                    mandateList={mandateList}
                    hasUserInvested={hasUserInvested}
                    pendingActions={pendingActions}
                    hideHeaderSearch={hideHeaderSearch}
                    showHeaderNavLinks={showHeaderNavLinks}
                    url={url}
                    isMobile={isMobile}
                    showNudge={showNudge}
                    nudgeRequired={nudgeRequired}
                  />
                ) : (
                  <NavbarCurrency
                    isUserLoggedIn={userInfo || this.state.userInfo}
                    hideHeaderSearch={hideHeaderSearch}
                    showHeaderNavLinks={showHeaderNavLinks}
                    url={url}
                    isMobile={isMobile}
                    showNudge={showNudge}
                    nudgeRequired={nudgeRequired}
                  />
                ))}

              {showMobileHeader ? (
                <MobileHeader
                  isUserLoggedIn={userInfo || this.state.userInfo}
                  alreadyInvested={hasUserInvested}
                />
              ) : null}

              {downloadInvestmentProof ? (
                <DownloadProof
                  onDismiss={() => {
                    this.setState({
                      downloadInvestmentProof: false,
                    });
                  }}
                  elssInvestmentYears={elssInvestmentYears}
                />
              ) : null}
              <ContainerLayout
                path={(url || {}).pathname}
                hasSidebar={showSidebar}
                mandateList={mandateList}
                hideHeader={hideHeader}
                hasUserInvested={hasUserInvested}
                pendingActions={pendingActions}
                fetchingPendingActions={fetchingPendingActions}
                mandateData={mandateData}
                showMobileHeader={showMobileHeader}
                userInfo={userInfo || {}}
                isMobile={isMobile}
                showNudge={showNudge}
                nudgeRequired={nudgeRequired}
                elssInvestmentYears={elssInvestmentYears}
                downloadElssProof={this.showInvestmentProofModal}
              >
                <ComposedComponent
                  {...this.state}
                  {...this.props}
                  userInfo={this.state.userInfo || this.props.userInfo}
                  hasUserInvested={hasUserInvested}
                  handleNavigation={this.handleNavigation}
                  fetchingPendingActions={fetchingPendingActions}
                  checkAbTest={true}
                />
                {!isMfPoliciesAccepted && (
                  <TncModal
                    globalPolicies={globalPolicies}
                    dismissTncModal={this.dismissTncModal}
                  />
                )}
              </ContainerLayout>
              {!hideFooter && <FooterNew urlPath={url} />}
              {loadOneTap ? (
                <GoogleYolo
                  id="g_id_onload"
                  data-client_id={GOOGLE_YOLO_CLIENT_ID}
                  data-auto_select="true"
                  data-cancel_on_tap_outside="false"
                  data-callback={this.authenticateUserFromGoogle}
                  handleSignIn={this.authenticateUserFromGoogle}
                />
              ) : null}
            </div>
          </section>
        </ApolloProvider>
      );
    }
  }

  return AppLayout;
};

export default withAppLayout;



// WEBPACK FOOTER //
// ./components/appLayout.tsx